import { axios } from "utils";

import { PUBLIC_CROP_EXPLORER_URL as endpoint } from "consts";

import {
  CropExplorationCreationResponse,
  CropExplorationEntryCreationResponse,
  CropExplorationEntryRequest,
  CropExplorationRequest,
  CropExplorationResponse,
} from "models";

export const addCropExploration = async (cropExploration: CropExplorationRequest): Promise<CropExplorationCreationResponse> =>
  axios.post(`${endpoint}/`, { data: cropExploration });

export const updateCropExploration = async ({ id, cropExploration }: { id: string; cropExploration: CropExplorationRequest }) =>
  axios.put(`${endpoint}/${id}`, { data: cropExploration });

export const getCropExplorations = async (pseudoUserId: CropExplorationRequest["pseudoUserId"], signal: AbortSignal): Promise<CropExplorationResponse[] | []> =>
  axios.get(`${endpoint}/?pseudoUserId=${pseudoUserId}`, { signal: signal });

export const deleteCropExploration = async ({ id, pseudoUserId }: { id: string; pseudoUserId: CropExplorationRequest["pseudoUserId"] }) =>
  axios.delete(`${endpoint}/${id}`, { data: { pseudoUserId } });

export const deleteCropExplorationEntriesByYear = async ({
  id,
  year,
  pseudoUserId,
  deleteYear,
}: {
  id: string;
  year: string;
  pseudoUserId: CropExplorationRequest["pseudoUserId"];
  deleteYear: boolean;
}) => axios.delete(`${endpoint}/entries/${id}/year/${year}?deleteYear=${deleteYear}`, { data: { pseudoUserId } });

export const addCropExplorationFromTemplate = async (cropExploration: CropExplorationRequest): Promise<CropExplorationCreationResponse> =>
  axios.post(`${endpoint}/create-from-template`, { data: cropExploration });

export const duplicateCropExplorationEntry = async ({
  id,
  sourceYear,
  targetYear,
  pseudoUserId,
}: {
  id: string;
  sourceYear: number;
  targetYear: number;
  pseudoUserId: CropExplorationRequest["pseudoUserId"];
}): Promise<{ ids: string[] }> => axios.post(`${endpoint}/${id}/years/${sourceYear}/duplicates?pseudoUserId=${pseudoUserId}`, { targetYear });

export const migratePseudoCropExplorationsToUser = async (pseudoUserId: CropExplorationRequest["pseudoUserId"]) =>
  axios.post(`${endpoint}/migrate/${pseudoUserId}`);

// Entries

export const addCropExplorationEntry = async ({
  cropExplorationId,
  crop,
  pseudoUserId,
}: {
  cropExplorationId: string;
  crop: CropExplorationEntryRequest;
  pseudoUserId: CropExplorationRequest["pseudoUserId"];
}): Promise<CropExplorationEntryCreationResponse> => axios.post(`${endpoint}/${cropExplorationId}/entries?pseudoUserId=${pseudoUserId}`, { data: crop });

export const updateCropExplorationEntry = async ({
  cropExplorationId,
  entryId,
  crop,
  pseudoUserId,
}: {
  cropExplorationId: string;
  entryId: string;
  crop: CropExplorationEntryRequest;
  pseudoUserId: CropExplorationRequest["pseudoUserId"];
}) => axios.put(`${endpoint}/${cropExplorationId}/entries/${entryId}?pseudoUserId=${pseudoUserId}`, { data: crop });

export const deleteCropExplorationEntry = async ({ id, pseudoUserId }: { id: string; pseudoUserId: CropExplorationRequest["pseudoUserId"] }) =>
  axios.delete(`${endpoint}/entries/${id}?pseudoUserId=${pseudoUserId}`);

export const dismissRecommendation = async ({
  cropExplorationId,
  year,
  pseudoUserId,
}: {
  cropExplorationId: string;
  year: number;
  pseudoUserId: CropExplorationRequest["pseudoUserId"];
}) => axios.post(`${endpoint}/${cropExplorationId}/dismiss-recommendation/${year}?pseudoUserId=${pseudoUserId}`);

// PseudoUsers

export const generatePseudoUserId = async (): Promise<{ pseudoUserId: string }> => axios.post(`${endpoint}/pseudo-user-id`);
